"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * DOMEventPlugin handles customized DOM events, including:
 * 1. IME state management
 * 2. Selection management
 * 3. Cut and Drop management
 * 4. Pending format state management
 * 5. Scroll container and scroll event management
 */
var DOMEventPlugin = /** @class */ (function () {
    function DOMEventPlugin(disableRestoreSelectionOnFocus) {
        var _this = this;
        this.disableRestoreSelectionOnFocus = disableRestoreSelectionOnFocus;
        this.inIme = false;
        this.onNativeEvent = function (e) {
            _this.editor.runAsync(function () {
                _this.editor.addUndoSnapshot(function () { }, e.type == 'cut' ? "Cut" /* Cut */ : "Drop" /* Drop */);
            });
        };
        this.onFocus = function () {
            if (_this.disableRestoreSelectionOnFocus) {
                if (_this.cachedPosition && _this.cachedFormatState) {
                    var range = _this.editor.getSelectionRange();
                    if (range.collapsed &&
                        roosterjs_editor_dom_1.Position.getStart(range).normalize().equalTo(_this.cachedPosition)) {
                        _this.restorePendingFormatState();
                    }
                    else {
                        _this.clear();
                    }
                }
            }
            else {
                _this.editor.restoreSavedRange();
            }
        };
        this.onBlur = function () {
            _this.editor.saveSelectionRange();
        };
        this.onScroll = function (e) {
            _this.editor.triggerPluginEvent(15 /* Scroll */, {
                rawEvent: e,
                scrollContainer: _this.editor.getScrollContainer(),
            });
        };
    }
    DOMEventPlugin.prototype.getName = function () {
        return 'DOMEvent';
    };
    DOMEventPlugin.prototype.initialize = function (editor) {
        var _a;
        var _this = this;
        this.editor = editor;
        this.disposer = editor.addDomEventHandler((_a = {
                // 1. IME state management
                compositionstart: function () { return (_this.inIme = true); },
                compositionend: function (rawEvent) {
                    _this.inIme = false;
                    editor.triggerPluginEvent(3 /* CompositionEnd */, {
                        rawEvent: rawEvent,
                    });
                },
                // 2. Cut and drop management
                drop: this.onNativeEvent,
                cut: this.onNativeEvent,
                // 3. Selection mangement
                focus: this.onFocus
            },
            _a[roosterjs_editor_dom_1.Browser.isIEOrEdge ? 'beforedeactivate' : 'blur'] = this.onBlur,
            _a));
        this.editor.getScrollContainer().addEventListener('scroll', this.onScroll);
    };
    DOMEventPlugin.prototype.dispose = function () {
        this.editor.getScrollContainer().removeEventListener('scroll', this.onScroll);
        this.disposer();
        this.disposer = null;
        this.editor = null;
        this.clear();
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    DOMEventPlugin.prototype.onPluginEvent = function (event) {
        switch (event.eventType) {
            case 13 /* PendingFormatStateChanged */:
                // Got PendingFormatStateChagned event, cache current position and pending format
                this.cachedPosition = this.getCurrentPosition();
                this.cachedFormatState = event.formatState;
                break;
            case 0 /* KeyDown */:
            case 4 /* MouseDown */:
            case 6 /* ContentChanged */:
                // If content or position is changed (by keyboard, mouse, or code),
                // check if current position is still the same with the cached one (if exist),
                // and clear cached format if position is changed since it is out-of-date now
                if (this.cachedPosition &&
                    !this.cachedPosition.equalTo(this.getCurrentPosition())) {
                    this.clear();
                }
                break;
        }
    };
    /**
     * Restore cached pending format state (if exist) to current selection
     */
    DOMEventPlugin.prototype.restorePendingFormatState = function () {
        var _this = this;
        if (this.cachedFormatState) {
            var formatState_1 = roosterjs_editor_dom_1.getPendableFormatState(this.editor.getDocument());
            Object.keys(roosterjs_editor_dom_1.PendableFormatCommandMap).forEach(function (key) {
                if (_this.cachedFormatState[key] != formatState_1[key]) {
                    _this.editor
                        .getDocument()
                        .execCommand(roosterjs_editor_dom_1.PendableFormatCommandMap[key], false, null);
                }
            });
            this.cachedPosition = this.getCurrentPosition();
        }
    };
    /**
     * Check if editor is in IME input sequence
     * @returns True if editor is in IME input sequence, otherwise false
     */
    DOMEventPlugin.prototype.isInIME = function () {
        return this.inIme;
    };
    DOMEventPlugin.prototype.clear = function () {
        this.cachedPosition = null;
        this.cachedFormatState = null;
    };
    DOMEventPlugin.prototype.getCurrentPosition = function () {
        var range = this.editor.getSelectionRange();
        return range && roosterjs_editor_dom_1.Position.getStart(range).normalize();
    };
    return DOMEventPlugin;
}());
exports.default = DOMEventPlugin;
//# sourceMappingURL=DOMEventPlugin.js.map